// src/components/ApiKeySection.js
import { useState } from 'react';
import { Button, Alert, Form } from 'react-bootstrap';
import apiClient, {apiURL} from '../api/api';

function ApiKeySection() {
  const [apiKey, setApiKey] = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [error, setError] = useState(null);
  const [csvSchemesUrl, setCsvSchemesUrl] = useState('');
  const [csvSchemeAlternatesUrl, setCsvSchemeAlternatesUrl] = useState('');
  const [csvSchemeNAVactualLatestUrl, setCsvSchemeNAVactualLatestUrl] = useState('');

  function isNullEmptyOrJustWhitespace(str) {
    return !str?.trim();
  }
  const handleGenerate = async () => {
    setError(null);
    try {
      const res = await apiClient.post('/api-key');
      setApiKey(res.data.api_key);
      console.log('API Key generated:', res.data.api_key);
      setCsvSchemeNAVactualLatestUrl(`${apiURL}/api/get-latest-act-pred-csv?api_key=${encodeURIComponent(res.data.api_key)}`);
      setCsvSchemesUrl(`${apiURL}/api/user-schemes-csv?api_key=${encodeURIComponent(res.data.api_key)}`);
      setCsvSchemeAlternatesUrl(`${apiURL}/api/user-scheme-alternates-csv?scheme_code=XXXXXX&api_key=${encodeURIComponent(res.data.api_key)}`);
      setExpiresAt(res.data.expires_at);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to generate API key');
    }
  };

  return (
    <div className="mt-4">
      <h5>API Key for data fetch in Excel (CSV output)</h5>
      {error && <Alert variant="danger">{error}</Alert>}

      {isNullEmptyOrJustWhitespace(apiKey) && (
        <>
          <Button onClick={handleGenerate} className="mb-3">
            Generate API Key (<i>Valid for 1 day</i>)
          </Button>
        </>
      )}
      {!isNullEmptyOrJustWhitespace(apiKey) && (
        <>
          <Alert variant="success">
            API Key is - '{apiKey}'. Save it for further use. <b>Valid till: {expiresAt}</b>
          </Alert>
          <Form.Group>
            <Form.Label>Get Performance and Probable values as CSV of Tracked Schemes from user selected Funds. <b>Copy and use as 'Data - From Web' in Excel</b></Form.Label>
            <Form.Control type="text" value={csvSchemesUrl} readOnly />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>URL to compare Scheme's alternatives (from user selected Funds), fetch as CSV (Copy, substitute Scheme_Code,  and use as 'Data - From Web' in Excel)</Form.Label>
            <Form.Control type="text" value={csvSchemeAlternatesUrl} readOnly />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>Compare Actual and Predicted NAV as CSV of Tracked Schemes. <b>Copy and use as 'Data - From Web' in Excel</b></Form.Label>
            <Form.Control type="text" value={csvSchemeNAVactualLatestUrl} readOnly />
          </Form.Group>
        </>
      )}
    </div>
  );
}

export default ApiKeySection;
